import { useTranslation } from 'react-i18next'
import appStoreCs from '../../assets/img/store-appstore-cs.svg'
import appStoreEn from '../../assets/img/store-appstore-en.svg'
import appStoreUk from '../../assets/img/store-appstore-uk.svg'
import googlePlayGreyCs from '../../assets/img/store-googleplay-grey-cs.svg'
import googlePlayGreyEn from '../../assets/img/store-googleplay-grey-en.svg'
import googlePlayGreyUk from '../../assets/img/store-googleplay-grey-uk.svg'
import googlePlayWhiteCs from '../../assets/img/store-googleplay-white-cs.svg'
import googlePlayWhiteEn from '../../assets/img/store-googleplay-white-en.svg'
import googlePlayWhiteUk from '../../assets/img/store-googleplay-white-uk.svg'
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../../config/constants'
import { ButtonElement, type ButtonLocation, trackButtonClick } from '../../utils/analyticsEvents'
import { LocalizedImage } from '../LocalizedImage/LocalizedImage'
import styles from './StoreButtons.module.scss'

type StoreButtonsVariant = 'grey' | 'white'

interface StoreButtonsProps {
  className?: string
  location: ButtonLocation
  variant?: StoreButtonsVariant
}

const APP_STORE_SOURCES = { cs: appStoreCs, en: appStoreEn, uk: appStoreUk }

const GOOGLE_PLAY_SOURCES = {
  grey: { cs: googlePlayGreyCs, en: googlePlayGreyEn, uk: googlePlayGreyUk },
  white: { cs: googlePlayWhiteCs, en: googlePlayWhiteEn, uk: googlePlayWhiteUk },
}

export const StoreButtons = ({ className = '', location, variant = 'grey' }: StoreButtonsProps) => {
  const { t } = useTranslation()
  const linkClassName = `${styles.link} ${styles[variant]}`

  return (
    <div className={`${styles.buttons} ${className}`.trim()}>
      <a
        aria-label={t('common.appStoreAria')}
        className={linkClassName}
        href={APP_STORE_URL}
        rel="noreferrer"
        target="_blank"
        onClick={() => {
          trackButtonClick(ButtonElement.DownloadAppApple, location)
        }}
      >
        <LocalizedImage alt="App Store" height="48" sources={APP_STORE_SOURCES} width="161" />
      </a>
      <a
        aria-label={t('common.googlePlayAria')}
        className={linkClassName}
        href={GOOGLE_PLAY_URL}
        rel="noreferrer"
        target="_blank"
        onClick={() => {
          trackButtonClick(ButtonElement.DownloadAppAndroid, location)
        }}
      >
        <LocalizedImage
          alt="Google Play"
          height="48"
          sources={GOOGLE_PLAY_SOURCES[variant]}
          width="161"
        />
      </a>
    </div>
  )
}
